export function capitalize(myString: string) {
  return myString.charAt(0).toUpperCase() + myString.slice(1);
}
